import { Component, OnInit, Input, Output, Inject, EventEmitter } from '@angular/core';
import { IResource } from '../../services/IResource';
import { SubCategory } from '../../../models/SubCategory';
import { ResourceService } from '../../services/resource.service';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-category-information',
  templateUrl: './category-information.component.html',
  styleUrls: ['./category-information.component.scss']
})
export class CategoryInformationComponent implements OnInit {
  private readonly HTTP_PREFIX_RE = /^https?:\/\//i;
  @Input() categoryLabel: string;
  @Input() categoryValue: string;
  @Input() categoryColor: string;
  @Input() pageValue: string;
  @Input() subcategory;
  @Input() category: Array<SubCategory>;
  @Input() isViewer: boolean;

  // Note: the string ref needs to be the format `<page>-<category>-<subcategory>`
  @Output() addAttachment = new EventEmitter<string>();
  @Output() editAttachment = new EventEmitter<{categoricalLocation: string, resource: IResource}>();
  @Output() deleteAttachment = new EventEmitter<{resource: IResource, label: string}>();

  constructor(@Inject(DOCUMENT) private document: Document,
      private resourceService: ResourceService) {
  }

  ngOnInit() {
  }

  iconImageSrc(resource: IResource) {
    return `assets/icons/${resource.fileGroupIcon}`;
  }

  altText(resource: IResource) {
    return resource.isUrl ? 'External Link' : 'Attached File';
  }

  getCategoryColor() {
    return { 'background-color' : this.categoryColor };
  }
  onClickAttachmentName(resource: IResource) {
      if (resource.isUrl) {
        if (!resource.resourcePath.match(this.HTTP_PREFIX_RE)) {
          // if the URL is not prefixed with HTTP, then add it.
          resource.resourcePath = `http://${resource.resourcePath}`;
        }
        window.open(resource.resourcePath);
      } else {
        const iframe = this.document.createElement('iframe');
        iframe.src = this.resourceService.transformToResourceDownloadUrl(resource);
        this.document.body.appendChild(iframe);
        setTimeout(() => iframe.remove(), 1000);
      }
    }

  displayEditAttachmentModal(subcategoryValue: string, resource: IResource) {
    this.editAttachment.emit({
      categoricalLocation: `${this.pageValue}-${this.categoryValue}-${subcategoryValue}`,
      resource: resource
    });
  }

  displayAttachmentModal(subcategoryValue: string) {
    this.addAttachment.emit(`${this.pageValue}-${this.categoryValue}-${subcategoryValue}`);
  }

  displayDeleteModal(resource: IResource, label: string) {
    this.deleteAttachment.emit({resource: resource, label: label});
  }

  formattedDate(dateStr: string) {
    const isoFormatted = `${dateStr.replace(' ', 'T')}Z`;
    const dateObj = new Date(isoFormatted);
    return `${dateObj.getMonth() + 1}/${dateObj.getDate()}/${dateObj.getFullYear()}`;
  }

}
